module.exports = {"component":"breadcrumb","status":"prod","display-name":"Breadcrumbs","last-accessibility-review":{"date-iso-8601":"2018/01/18","commit-sha":"ad6b6c6523ee21cada11be5f7ea4d99abc530726"},"SLDS-component-path":"/components/breadcrumbs","url-slug":"breadcrumbs"}


//////////////////
// WEBPACK FOOTER
// ./components/breadcrumb/docs.json
// module id = 185
// module chunks = 0